module.exports = __webpack_public_path__ + "images/emoji/mobile_phone_off.285d2b0176561b7e52a3.png";